import { matchPath } from "react-router-dom";

export const isOnWorkspaceConfigurationRoute = (pathname: string) => {
  return (
    matchPath(`/projects/:workspaceId/configuration`, pathname) ||
    matchPath(`/workspaces/:workspaceId/configuration`, pathname)
  );
};
